import { render, staticRenderFns } from "./TableCellTypeJson.vue?vue&type=template&id=9027ed96&scoped=true"
import script from "./TableCellTypeJson.vue?vue&type=script&lang=js"
export * from "./TableCellTypeJson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9027ed96",
  null
  
)

export default component.exports